import * as API from '../utilities/api';
import { InputStep } from '../components/Checkout/Checkout';
import { getPrice } from '../selectors/index';
import { getDiscount } from '../selectors/discount';

export const RECIEVE_GIFT_CARD = 'RECIEVE_GIFT_CARD';
export const UPDATE_AMOUNT_TO_CHARGE = 'UPDATE_AMOUNT_TO_CHARGE';
export const RESET_GIFT_CARD = 'RESET_GIFT_CARD';
export const ADD_GIFT_CARD = 'ADD_GIFT_CARD';
export const REMOVE_GIFT_CARD = 'REMOVE_GIFT_CARD';
export const SET_GIFT_CARD_NUMBER = 'SET_GIFT_CARD_NUMBER';
export const SET_GIFT_CARD_PIN = 'SET_GIFT_CARD_PIN';
export const SET_POINT_NUMBER = 'SET_POINT_NUMBER';
export const RESET_CURRENT_GIFT_CARD = 'RESET_CURRENT_GIFT_CARD';
export const RESET_CURRENT_AMOUNT = 'RESET_CURRENT_AMOUNT';
export const RESET_POINT_AMOUNT = 'RESET_POINT_AMOUNT';

export function receiveGiftCard(giftCardNumber, balance_remaining) {
  return {
    type: RECIEVE_GIFT_CARD,
    giftCardNumber,
    balance_remaining
  };
}

export function setGiftCardNumber(giftCardNumber) {
  return {
    type: SET_GIFT_CARD_NUMBER,
    giftCardNumber
  }
}

export function setGiftCardPinNumber(pinNumber){
  return {
    type: SET_GIFT_CARD_PIN,
    pinNumber
  }
}

export function setPointNumber(pointId) {
  return {
    type: SET_POINT_NUMBER,
    pointId
  }
}

export function updateGiftCardAmountToCharge(amount) {
  return {
    type: UPDATE_AMOUNT_TO_CHARGE,
    amount
  };
}

export function resetGiftCard() {
  return {
    type: RESET_GIFT_CARD
  };
}

export function resetCurrentGiftCard() {
  return {
    type: RESET_CURRENT_GIFT_CARD
  };
}

export function resetCurrentAmount() {
  return {
    type: RESET_CURRENT_AMOUNT
  };
}

export function resetPointAmount() {
  return {
    type: RESET_POINT_AMOUNT
  };
}

export function addGiftCard(amount) {
  return {
    type: ADD_GIFT_CARD,
    amount
  };
}

export function removeGiftCard(giftcard_number, amount) {
  return {
    type: REMOVE_GIFT_CARD,
    giftcard_number,
    amount
  };
}


export function trySelectGiftCard(giftCard, secCode) {
  return (dispatch, getState) => {
    const state = getState();

    const cardNumber = giftCard.toUpperCase();

    return new Promise((resolve, reject) => {
      API.checkGiftCard(cardNumber, secCode)
        .then(result => {
          if(!result.has_record && !cardNumber.match("^[0-9.]+$") && !secCode)           reject(InputStep.PinNeeded); // Pin Required on this one

          else if (!result.has_record) reject(InputStep.NotFoundCard);
          else if (result.is_in_use || !result.is_active) reject(InputStep.CardFoundNotAvailable);
          else if (!result.balance_remaining > 0) reject(InputStep.CardNoBalance); // Probably change this to something else. Like no balance. Let em know.
          else if (result.currency !== state.bookingLocation.selectedLocation.currency) reject(InputStep.CurrencyMismatch); // Currency Mismatch...
          // Probably more stuff here.
          else {
            dispatch(receiveGiftCard(result.gift_card_number, parseFloat(result.balance_remaining)));

            const priceInfo = getPrice(state, getDiscount(state));
            const price_to_charge = Math.max(priceInfo.basePrice - priceInfo.discount, 0) + priceInfo.tax;
            dispatch(updateGiftCardAmountToCharge((parseFloat(result.balance_remaining) < price_to_charge) ? parseFloat(result.balance_remaining) : price_to_charge));
            resolve();
          }
        })
        .catch(() => reject(InputStep.NotFoundCard));
    });
  }
}

export function getPointsCard(response, loginType) {
  return (dispatch, getState) => {
    return new Promise ((resolve, reject) => {
      API.getPointsCard(response, loginType)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
    }) 
  }
}
